import { Component } from '@angular/core';
import { ChangePasswordComponent } from './change-password.component';

@Component({
  selector: 'tpo-change-password',
  templateUrl: './tpo-change-password.component.html',
  standalone: false,
})
export class TpoChangePasswordComponent extends ChangePasswordComponent {}
